// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2Fxxi","description":"PatientConsentPreview_description__2QfAj"};